/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.24",
    versionName: "0.2.0-nightly.2026.3.24",
    versionChannel: "nightly",
    buildDate: "2026-03-24T00:10:31.145Z",
    commitHash: "de06f365ca4bee7b80ad8a4f1b84d5426c6e89c1",
};
